
module.exports.DEFAULT_ENDPOINT = 'https://api.mapbox.com';



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox/lib/constants.js
 ** module id = 1813
 ** module chunks = 0
 **/